export default __webpack_public_path__ + "static/media/x_wdt_c_2.2c883229.mp3";